export const bookingStyles = {
  space: {
    dialogMargin: '20px'
  },
  buttons: {
    primaryLg: {
      variant: 'buttons.primary'
    }
  },
  sizes: {
    tabListWidth: '430px'
  }
} as const;
